export const STOP_STATUS = {
  UNSTARTED: 'unstarted',
  ARRIVED: 'arrived',
  CANCELED: 'canceled',
  ATTEMPT: 'attempt',
  COMPLETE: 'complete',
};
